<template>
    <div>
        <div>
            <div v-for="item in levels" :key="item._id">
                <div v-show="editedItem != item._id" class="template">
                    <h5 ><span>Poziom awarii: </span>{{item.level}}</h5>
                    <div class="buttons" v-show="confirmation != item._id">
                        <b-button class="button" v-on:click="editLevel(item._id, item.level)">Edytuj</b-button>
                        <b-button class="button" v-on:click="delLevel(item._id)">Usuń</b-button>
                    </div>
                    <div v-if="confirmation === item._id" class="confirm">Czy napewno chcesz usunąć ten poziom awarii ?
                        <b-button class="button" v-on:click="confirmDelLevel(item._id)">Tak</b-button>
                        <b-button class="button" v-on:click="cancelDelMessage()">Nie</b-button>
                    </div>
                </div>
                <div v-if="editedItem == item._id" class="template">
                    <h5 ><span>Poziom awarii: </span><b-input v-model="levelToEdit"></b-input></h5>
                    <div class="buttons">
                        <b-button class="button" v-on:click="applyChanges(item._id, levelToEdit)">Zatwierdź</b-button>
                        <b-button class="button" v-on:click="cancelChanges(item._id)">Anuluj</b-button>
                    </div>
                </div>
            </div>
            <b-button v-show="!newLevel" class="button" v-on:click="addLevel()">Dodaj Poziom</b-button>
            <div v-show="newLevel" class="template">
                <h5 ><span>Poziom awarii: </span><b-input v-model="newLevelName"></b-input></h5>
                <div class="buttons">
                    <b-button class="button" v-on:click="sendPost()">Zatwierdź</b-button>
                    <b-button class="button" v-on:click="cancelAdding()">Anuluj</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import{path} from '../../../config';
export default {
    name: 'AlertLevelCMS',
    methods: {
        editLevel: function(id, level){
            this.editedItem = id;
            this.levelToEdit = level;
        },
        delLevel: async function(id){
            this.confirmation = id;
            this.editedItem = '';
        },
        confirmDelLevel: async function(id){
            await axios
                .delete(`${path}levels/${id}`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('message deleted')
            this.$emit('shutLevels', 'Usunięto poziom awarii');
        },
        cancelChanges: function(){
            this.editedItem = '';
        },
        applyChanges: function(id, level){
            this.editedItem = '';
            const payload = {
                level: level,
            } 
            axios
                .put(`${path}levels/${id}`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.changeLevels(id);
        },
        changeLevels: function(id){
            for(let item of this.levels){
                if(item._id === id){
                    item.level = this.levelToEdit;
                }
            }
        },
        addLevel: function(){
            this.newLevel = true;
        },
        cancelAdding: function(){
            this.newLevel = false;
            this.newLevelName = '';
        },
        cancelDelMessage: function() {
            this.confirmation = '';
        },
        sendPost: async function(){
            const payload = {
                level: this.newLevelName,
            } 
            await axios
                .post(`${path}levels`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.newLevel = false;
            console.log('message sent')
            this.$emit('shutLevels', 'Dodano nowy poziom awarii');
        },
    },
    props:['dbLevels'],
    data: function(){
        return{
           levels: this.dbLevels,
           confirmation: '',
           editedItem: '',
           levelToEdit: '',
           newLevel: false,
           newLevelName: '',
        }
    }
}
</script>
<style lang="scss" scoped>
    .template {
        border-top: solid;
        border-bottom: solid;
        border-color: blue;
        border-width: 2px;
        border-radius: 10px;
        margin-bottom: 5px;
        text-align: left;
        padding-left: 10px;
        .buttons {
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 5px;
        }
        span {
            font-weight: bold;
        }
    }
    .confirm{
        background-color: red;
        margin: 10px 0;
        border-radius: 10px;
        color: white;
        padding: 0 5px;
        .button {
            margin: 5px;
        }
    }
</style>